import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsCtx = createContext({ settings: null, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsCtx.Provider value={{ settings, refresh }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
